import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import axios from 'axios';
import { requestInterceptor, requestErrorInterceptor } from './interceptors.request';
import { responseInterceptor, responseErrorInterceptor } from './interceptors.response';
export interface ApiFactoryOptions {
  baseURL: string;
  withAuth?: boolean;
  axiosConfig?: Omit<AxiosRequestConfig, 'baseURL' | 'headers'>;
  extraHeaders?: Record<string, string>;
  customRequestInterceptor?: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig | Promise<InternalAxiosRequestConfig>;
  customResponseInterceptor?: (response: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>;
}

export function createApiInstance(options: ApiFactoryOptions): AxiosInstance {
  const instance = axios.create({
    baseURL: options.baseURL,
    headers: {
      'Content-Type': 'application/json',
      ...(options.extraHeaders || {}),
    },
    ...options.axiosConfig,
  });

  instance.interceptors.request.use(
    async (config) => {
      let coreConfig = await requestInterceptor(config as InternalAxiosRequestConfig, {
        withAuth: options?.withAuth ?? true,
      });
      if (options.customRequestInterceptor) {
        coreConfig = await options.customRequestInterceptor(coreConfig);
      }
      // evitamos el undefined
      coreConfig.headers = coreConfig.headers || {};
      return coreConfig as InternalAxiosRequestConfig;
    },
    requestErrorInterceptor
  );

  instance.interceptors.response.use(
    async (response) => {
      let coreResponse = responseInterceptor(response);
      if (options.customResponseInterceptor) {
        coreResponse = await options.customResponseInterceptor(coreResponse);
      }
      return coreResponse;
    },
    responseErrorInterceptor
  );

  return instance;
}